export function isValid(prop: unknown) {
  return typeof prop !== 'undefined' && prop !== null;
}

export const validateEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
